import type { ReviewPrompt } from './operator-review'

/** Accept a complete review frame only for the current, not locally completed session. */
export function receiveReviewPrompt(
  data: unknown,
  sessionId: string | null,
  reviewedSessions: string[]
): ReviewPrompt | null {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null
  const payload = data as Record<string, unknown>
  if (!sessionId || payload.session_id !== sessionId || reviewedSessions.includes(sessionId)) return null
  if (
    !Array.isArray(payload.operators) ||
    !payload.operators.length ||
    !Array.isArray(payload.themes) ||
    !payload.themes.length
  )
    return null
  const operators = []
  for (const candidate of payload.operators) {
    if (
      !candidate ||
      typeof candidate !== 'object' ||
      typeof candidate.id !== 'string' ||
      !candidate.id.trim() ||
      typeof candidate.name !== 'string' ||
      !candidate.name.trim()
    )
      return null
    operators.push({ id: candidate.id, name: candidate.name })
  }
  const themes = []
  for (const candidate of payload.themes) {
    if (!candidate || typeof candidate !== 'object' || typeof candidate.name !== 'string' || !candidate.name.trim())
      return null
    if (candidate.required !== undefined && typeof candidate.required !== 'boolean') return null
    const displayNames = candidate.display_names
    if (
      displayNames !== undefined &&
      (!displayNames ||
        typeof displayNames !== 'object' ||
        Array.isArray(displayNames) ||
        Object.values(displayNames).some(value => typeof value !== 'string'))
    )
      return null
    themes.push({
      name: candidate.name,
      ...(candidate.required !== undefined ? { required: candidate.required } : {}),
      ...(displayNames !== undefined ? { display_names: { ...displayNames } } : {})
    })
  }

  return { session_id: sessionId, operators, themes }
}
